import React, {useState} from 'react';
import {Accordion as Acc} from 'react-bootstrap';
import {Panel, CardContainer} from './styles';
import Header from './Header';
import Body from './Body';
import {Question} from '../../../models/Questions';

interface Props {
  data?: Question[];
  className?: any;
}

const Accordion: React.FC<Props> = ({data, className}) => {
  return (
    <Acc flush className={className}>
      <Panel>
        {data?.map((item, index) => {
          return (
            <CardContainer key={index}>
              <Header eventKey={index.toString()}>{item.title}</Header>
              <Body eventKey={index.toString()}>{item.body}</Body>
            </CardContainer>
          );
        })}
      </Panel>
    </Acc>
  );
};

/**
 * 
 * <CardContainer>
          <Header eventKey="1">Hey</Header>
          <Body eventKey="1">I am the body</Body>
        </CardContainer>
 */

export default Accordion;
